//Generated File 
export default class DownloadPurpose{
	static readonly DOWNLOAD = `DOWNLOAD`;
	static readonly PREVIEW = `PREVIEW`;
	static readonly PRINT = `PRINT`;
	static readonly THUMBNAIL = `THUMBNAIL`;
}
